// @flow

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getCurrentRoomId,
  getConversationModalId,
  getConversationModalVisibility,
} from "src/reducers";
import { downloadFile } from "src/actions/file";
import location from "src/constants/location";

import type { UnifizeFile } from "src/types";

import File from "./File";
import OldFiles from "./OldFiles";
import { FileGridList } from "./styles";

type Props = {
  newValue: Array<string>,
  oldValue: Array<string>,
};

const Files = ({ newValue = [], oldValue = [] }: Props) => {
  const dispatch = useDispatch();

  const modal = useSelector(({ app }) => getConversationModalVisibility(app));
  const roomId = useSelector(({ app }) => getCurrentRoomId(app));
  const modalId = useSelector(({ app }) => getConversationModalId(app));

  const handleDownload = (file: UnifizeFile) => {
    dispatch(
      downloadFile({
        roomId: modal ? modalId : roomId,
        location: modal ? location.conversationDialog : location.chatHistory,
        name: file.name,
        originalName: file.originalName,
        generation: file.generation,
        versionId: file.versionId,
      }),
    );
  };

  return (
    <FileGridList>
      {oldValue.length > 0 && <OldFiles oldFileIds={oldValue} />}
      {newValue.map((fileId) => (
        <File key={fileId} handleDownload={handleDownload} id={fileId} />
      ))}
    </FileGridList>
  );
};

export default Files;
